import { Bot } from 'lucide-react';
import type { AgentStats } from '@/lib/bots/edge';

/**
 * Tiny "a bot is here" marker for the Value Dashboard market rows + the trade
 * sidebar. Emerald when any bot on the market is claimed; muted otherwise.
 * Renders nothing when there are no bots.
 */
export function BotPresenceChip({ bots }: { bots: AgentStats[] | undefined }) {
  if (!bots || bots.length === 0) return null;
  const owned = bots.some((b) => b.owner);
  return (
    <span
      title={`${bots.length} bot${bots.length === 1 ? '' : 's'} on this market${owned ? ' (claimed)' : ''}`}
      className={`inline-flex items-center gap-0.5 rounded px-1 py-px text-[9px] font-medium ${
        owned ? 'bg-emerald-500/15 text-emerald-400' : 'bg-foreground/10 text-muted-foreground'
      }`}
    >
      <Bot size={9} />
      {bots.length > 1 ? bots.length : ''}
    </span>
  );
}
